<template>
  <button
    type="button"
    v-bind="$attrs"
    class="mb-1 w-full flex justify-center items-center gap-2 bg-primary hover:bg-primary-hover active:bg-primary-pressed text-background text-lg font-semibold py-[10px] px-[14px] rounded-lg disabled:bg-disable"
    :class="classes"
    @click="$emit('click')"
  >
    <slot name="preffix-icon"></slot>
    <slot name="title"></slot>
  </button>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  emits: {
    click: null,
  },
};
</script>

<style lang="scss">
button:disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>
